import FormField from "components/inputs/FormField/FormField";
import { FormikProvider, useFormik } from "formik";
import { useCallback } from "react";

import Histogram from "components/Histogram/Histogram";
import Range from "components/Range/Range";
import IconButton from "components/buttons/IconButton/IconButton";

import ReloadIcon from "assets/icons/reload.svg";

import styles from "./histogram-range.module.scss";

const HistogramRange = ({ statistics, onUpdateRange }) => {
  const formik = useFormik({
    validateOnChange: true,
    initialValues: {
      min: statistics.percentiles[0],
      max: statistics.percentiles[1]
    },
    validateOnMount: true,
    enableReinitialize: true,

    onSubmit: (val) => {
      onUpdateRange([val.min, val.max]);
    }
  });

  const onChangeValues = useCallback((e) => {
    formik.setFieldValue(e.target.name, e.target.value);
    formik.submitForm();
  }, []);

  if (!statistics) return null;
  return (
    <div className={styles["wrapper"]}>
      <div className={styles["histogram-range"]}>
        <Histogram
          frequencies={statistics.histogram[0]}
          bins={statistics.histogram[1]}
        />
        <Range
          value={statistics.percentiles}
          min={statistics.min}
          max={statistics.max}
          containerClassName={styles["range"]}
          onChange={onUpdateRange}
        />
      </div>
      <div className={styles["form"]}>
        <FormikProvider value={formik}>
          <div className={styles["field"]}>
            <label>Min</label>
            <FormField
              name={"min"}
              type="number"
              onChange={onChangeValues}
            ></FormField>
          </div>
          <div className={styles["field"]}>
            <label>Max</label>
            <FormField name={"max"} onChange={onChangeValues}></FormField>
          </div>
          {statistics.originalPercentiles && (
            <IconButton
              onClick={() => onUpdateRange()}
              icon={ReloadIcon}
              alt={""}
            />
          )}
        </FormikProvider>
      </div>
    </div>
  );
};

export default HistogramRange;
